import { useContext } from 'react';
import { CompanyContext } from '../providers/CompanyProvider';

const useCompany = () => {
  const contextValue = useContext(CompanyContext);

  if (!contextValue)
    throw new Error('Please make sure your component tree is wrapped with CompanyProvider component');

  return contextValue;
};

export default useCompany
